// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// ##### 25-01-22 Komarov
import { LoadingOutlined } from '@ant-design/icons';
import {
  getGeneralGeo,
  getTopHotels,
  resetHotelsAvail,
} from '../../../../../Redux/actions';
// ##### 23-11-08 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import LargeScreenTopHotels from './LargeScreenTopHotels';
import MediumScreenTopHotels from './MediumScreenTopHotels';
import SmallScreenTopHotels from './SmallScreenTopHotels';
// ##### 24-08-07 Komarov
import moment from 'moment';
import dateFormats from '../../../../../helpers/dateFormats';
// ##### 24-12-26 Komarov
import { makeParamsString } from '../../../Helpers/helper';
// ##### 24-12-27 Komarov
import { encryptString } from '../../../../../helpers/crypto';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../../hooks/usePerformanceMeasure';

// ##### Komarov 2025-07-14
const TopHotels = () => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('TopHotels', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for TopHotels (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  // ##### Komarov 2025-07-28
  const deviceType = useSelector(state => state.deviceType);
  const dispatch = useDispatch();
  // $$$$$ 23-01-24 Komarov: Подправил взятие tophotels из localStorage при переключении на главную страницу с другой при действии уже клиентского кода (например, когда пользователь зашёл сначала не на главную страницу сайта, а потом переключился на главную)
  // ##### Komarov 2025-07-28
  const tophotels = useSelector(state => state.tophotels.tophotels[locale]);
  // ##### 24-03-21 Komarov
  // const TopHotelContents = (tophotels.length > 0 && tophotels) || JSON.parse(localStorage.getItem("tophotels")).tophotels;
  // ##### Komarov 2025-07-28
  const TopHotelContents = tophotels?.length > 0 && tophotels;

  const history = useHistory();

  // ##### 24-07-25 Komarov
  const pickedcurrencyFromState = useSelector(
    state => state.currency.pickedcurrency
  );
  // ##### 24-07-25 Komarov
  const pickedcurrency =
    pickedcurrencyFromState ||
    JSON.parse(localStorage.getItem('currency')).pickedcurrency;

  // ##### 24-07-25 Komarov
  const citiesGenLocs = useSelector(state => state.cities.gen_locs);

  // ##### 25-02-21 Komarov: Очищаем значение hotels_avail в Redux
  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(resetHotelsAvail());
  }, []);
  ///получаю из смарта тур имя, тур айди, сити имя, сити айди
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-03-21 Komarov
    citiesGenLocs.length > 0 ||
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/PageComponents/HomePage/TopHotels.js:getGeneralGeo()'
      );
    // dispatch (getGeneralGeo ());
    // ##### 24-07-25 Komarov
    citiesGenLocs.length > 0 || dispatch(getGeneralGeo());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### Komarov 2025-07-28
    tophotels?.length > 0 ||
      // ##### 25-04-30 Komarov
      uniLog(
        'axios:src/Components/Pages/PageComponents/HomePage/TopHotels.js:getTopHotels()'
      );
    // dispatch(getTopHotels());
    // ##### Komarov 2025-07-28
    tophotels?.length > 0 || dispatch(getTopHotels({ language: locale, deviceType }));
    // dispatch(getTopHotels({ language: locale, deviceType }));
    // ##### 24-03-21 Komarov
  }, [dispatch, locale, deviceType]);

  // ##### Komarov 2025-08-05
  const chooseAnotherHotel =
    useSelector(state => state.pagesRedux[state.language]?.ChooseAnotherHotel || '');

  // ##### Komarov 2025-08-02
  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );

  const GetHotelDetails = hotel => e => {
    let route_query;
    // ##### 24-08-07 Komarov
    const start = moment().add(1, 'days').format(dateFormats.en);
    const end = moment().add(2, 'days').format(dateFormats.en);
    if (e.target.id) {
      // ##### 24-12-26 Komarov
      const params_string = makeParamsString({
        selected_currency: pickedcurrency,
        start,
        end,
        title: hotel.hotel_name,
        // ##### 25-02-25 Komarov
        // id: hotel.hotel_id,
        city_id: hotel.city_id,
        adults: 1,
        children: 0,
        rooms: 1,
        hotel_name: hotel.hotel_name,
        // ##### 25-04-21 Komarov
        id: hotel.hotel_id, // hotel's id
      });
      // ##### 24-08-07 Komarov
      /*route_query = `/${locale}/hotel_details/?selected_currency=${pickedcurrency}&start=${start}&end=${end}&title=${hotel.hotel_name}&id=${hotel.hotel_id
        }&city_id=${hotel.city_id}&adults=1&children=0&rooms=1&hotel_name=${hotel.hotel_name
        }&hotel_id=${hotel.hotel_id}`;*/
      // ##### 24-12-27 Komarov
      // route_query = `/${locale}/hotel_details/?${params_string}`;

      route_query = `/${locale}/hotel_details/?${shouldCypherUrlParams ? encryptString(params_string) : params_string}`;
    } else {
      route_query = '/';
      // ##### 23-09-07 Komarov
      alert(chooseAnotherHotel);
    }

    history.push(route_query);
  };

  if (!TopHotelContents) {
    return (
      <div>
        {' '}
        <LoadingOutlined />
      </div>
    );
  }

  return (
    <div
      style={{ order: '4', marginLeft: 'auto', marginRight: 'auto' }}
      data-component="TopHotels"
    >
      {/* ##### 23-11-08 Komarov */}
      <Media greaterThanOrEqual="Tablet-768-1024">
        <LargeScreenTopHotels
          TopHotelContents={TopHotelContents}
          GetHotelDetails={GetHotelDetails}
        />
      </Media>
      <Media at="Mobile-L-425-768">
        <MediumScreenTopHotels
          TopHotelContents={TopHotelContents}
          GetHotelDetails={GetHotelDetails}
        />
      </Media>
      <Media lessThan="Mobile-L-425-768">
        <SmallScreenTopHotels
          TopHotelContents={TopHotelContents}
          GetHotelDetails={GetHotelDetails}
        />
      </Media>
    </div>
  );
};

export default TopHotels;
